import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback, useRef } from 'react';

import type { ConversationListHandle } from '@common/components/conversations/ConversationList';
import type { ConversationListRow } from '@ekhodealer/ekho-common';

import { ConversationList } from '@common/components/conversations/ConversationList';

import { navigateToConversationAtom } from '../../atoms/conversationAtoms';
import { leadDetailsDrawerAtom } from '../../atoms/leadDetailsDrawerAtoms';

export const ConversationsTabContent = (): React.ReactNode => {
	const { selectedRow } = useAtomValue(leadDetailsDrawerAtom);
	const navigateToConversation = useSetAtom(navigateToConversationAtom);
	const listRef = useRef<ConversationListHandle>(null);

	const handleSelectConversation = useCallback(
		(conversation: ConversationListRow) => {
			navigateToConversation({
				conversationId: conversation.conversationId,
				title: conversation.interest ?? 'Conversation',
			});
		},
		[navigateToConversation],
	);

	return (
		<ConversationList
			ref={listRef}
			selectedId={null}
			onSelect={handleSelectConversation}
			searchParams={{ filters: { leadId: selectedRow?.id } }}
		/>
	);
};
